import React, { FC } from "react";
import cn from "classnames";
import ReactPaginate, { ReactPaginateProps } from "react-paginate";

import { ReactComponent as PrevIcon } from "src/assets/icons/arrow-next.svg";
import { ReactComponent as NextIcon } from "src/assets/icons/arrow-next.svg";

const ICON_SIZE = 18;

const DEFAULT_PAGE_CLASSNAME = "hidden xs:block min-w-10 min-h-11 text-lg";
const DEFAULT_PAGE_LINK_CLASSNAME =
  "block px-3 py-2 w-full text-center border border-opacity-50 rounded-lg hover:bg-purple-base hover:text-white-base hover:border-purple-base hover:opacity-100";
const DEFAULT_DISABLED_LINK_CLASSNAME =
  "flex items-center min-h-11 px-3 py-2 text-lg border border-opacity-50 rounded-lg hover:bg-purple-base hover:text-white-base hover:border-purple-base";
const DEFAULT_DISABLED_NAV_LINK_CLASSNAME = "pointer-events-none";

interface Props {
  className?: string;
  page: number;
  pageCount: number;
  pageRangeDisplayed?: number;
  marginPagesDisplayed?: number;
  setPage: (value: number) => void;
}

export const Pagination: FC<Props> = ({
  className,
  page,
  pageCount,
  pageRangeDisplayed = 5,
  marginPagesDisplayed = 3,
  setPage,
}) => {
  const currentPage = page - 1;

  const onPageChange: ReactPaginateProps["onPageChange"] = ({ selected }) =>
    setPage(selected + 1);

  return (
    <ReactPaginate
      containerClassName={cn("flex items-center gap-3", className)}
      pageClassName={DEFAULT_PAGE_CLASSNAME}
      pageLinkClassName={DEFAULT_PAGE_LINK_CLASSNAME}
      breakClassName={DEFAULT_PAGE_CLASSNAME}
      breakLinkClassName={DEFAULT_PAGE_LINK_CLASSNAME}
      activeClassName="!block default:opacity-100"
      activeLinkClassName="bg-purple-base text-white-base border-none"
      previousLinkClassName={DEFAULT_DISABLED_LINK_CLASSNAME}
      nextLinkClassName={DEFAULT_DISABLED_LINK_CLASSNAME}
      disabledLinkClassName={DEFAULT_DISABLED_NAV_LINK_CLASSNAME}
      disabledClassName="!opacity-50"
      initialPage={currentPage}
      pageCount={pageCount}
      pageRangeDisplayed={pageRangeDisplayed}
      marginPagesDisplayed={marginPagesDisplayed}
      onPageChange={onPageChange}
      previousLabel={
        <PrevIcon className="rotate-180" width={ICON_SIZE} height={ICON_SIZE} />
      }
      nextLabel={<NextIcon width={ICON_SIZE} height={ICON_SIZE} />}
      // previousLabel={"prev"}
      // nextLabel={"next"}
    />
  );
};
